/**
 * 项目配置文件
 */
var config = {
    // 储存的表名
    tableName : "html",
    // 储存的token名
    tokenName : "Authorization",
    // 记住密码功能cookie名字
    cookiesName: {
        checked: "html_CHECKED",
        userName: "html_USERNAME",
        password: "html_PASSWORD",
    },
}


export default config